import clsx from "clsx"
import { Text, Image } from "@/elements"

const ClientTag = () => {
  return (
    <div
      className="1/2 absolute bottom-[-4px] left-1/2 flex h-[16px] -translate-x-1/2 transform flex-col items-center justify-center rounded-sm bg-bg-1 px-1"
      style={{
        boxShadow: "0px 4px 24px 0px rgba(0, 0, 0, 0.10)",
      }}>
      <Text variant="caption" element="span">
        Client
      </Text>
    </div>
  )
}

export const MessagesAvatar: React.FC<{
  size?: "small" | "medium" | "default"
  src: string
  alt: string
  rounded?: boolean
  className?: string
  showClientTag?: boolean
}> = ({ size = "default", src, alt, rounded = false, className, showClientTag }) => {
  const { sizeClass, roundedClass } = {
    small: {
      sizeClass: rounded ? "size-[30px]" : "w-[24px] h-[30px]",
      roundedClass: rounded ? "rounded-full" : "rounded-sm",
    },
    medium: {
      sizeClass: rounded ? "size-[40px]" : "w-[30px] h-[43px] ",
      roundedClass: rounded ? "rounded-full" : "rounded-md",
    },
    default: {
      sizeClass: rounded ? "size-[50px]" : "w-[50px] h-[64px]",
      roundedClass: rounded ? "rounded-full" : "rounded-lg",
    },
  }[size]

  return (
    <div className="relative">
      <div className={clsx("relative overflow-hidden bg-bg-3", roundedClass, sizeClass, className)}>
        {src && (
          <Image
            srcSetUrls={{
              sm: src,
            }}
            alt={alt}
            className="h-full w-full object-cover"
          />
        )}
      </div>
      {showClientTag && <ClientTag />}
    </div>
  )
}
